import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Redirect, Route, Switch, useHistory, useParams } from 'react-router-dom';
import { useFormStyles } from '../../styles/useFormStyles';
import {
  route,
  PARTNER_DETAILS_TABS,
  partnerDetailsParameters,
  partnerDetailsRoute,
} from '../../utils/routing';
import { ViziTab, ViziTabs } from '../../utils/ViziTabs';
import PartnerDetailsOverview from './PartnerDetailsOverview';
import PartnerDetailsEvents from './PartnerDetailsEvents';
import PartnerDetailsLocations from './PartnerDetailsLocations';
import dashboardStore from '../../state/dashboardStore';
import { PAGES } from '../../components/main/MainComponent';

const PartnerDetails = observer(() => {
  const formClasses = useFormStyles();
  const { partnerid } = useParams<{ partnerid: string }>();
  const history = useHistory();

  useEffect(() => {
    dashboardStore.appBarLabel = 'Partner details';
  }, [history.location]);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <div className={formClasses.root}>
          <div className={formClasses.verticalRoot}>
            <ViziTabs
              basePath={partnerDetailsParameters(partnerid)}
              tabs={Object.values(PARTNER_DETAILS_TABS)}
            >
              <ViziTab
                label={PARTNER_DETAILS_TABS.OVERVIEW}
                linkTo={partnerDetailsParameters(partnerid, PARTNER_DETAILS_TABS.OVERVIEW)}
              />
              <ViziTab
                label={PARTNER_DETAILS_TABS.EVENTS}
                linkTo={partnerDetailsParameters(partnerid, PARTNER_DETAILS_TABS.EVENTS)}
              />
              <ViziTab
                label={PARTNER_DETAILS_TABS.LOCATIONS}
                linkTo={partnerDetailsParameters(partnerid, PARTNER_DETAILS_TABS.LOCATIONS)}
              />
            </ViziTabs>

            <Switch>
              <Route path={partnerDetailsRoute(PARTNER_DETAILS_TABS.OVERVIEW)}>
                <PartnerDetailsOverview partnerid={partnerid} />
              </Route>
              <Route path={partnerDetailsRoute(PARTNER_DETAILS_TABS.EVENTS)}>
                <PartnerDetailsEvents partnerid={partnerid} />
              </Route>
              <Route path={partnerDetailsRoute(PARTNER_DETAILS_TABS.LOCATIONS)}>
                <PartnerDetailsLocations partnerid={partnerid} />
              </Route>
              <Route path={route(PAGES.Partners)}>
                <Redirect to={partnerDetailsParameters(partnerid, PARTNER_DETAILS_TABS.OVERVIEW)} />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PartnerDetails;
